import { Resolver } from '../../Container';

export interface TutorialStep {
    readonly id: string;
    run(r: Resolver): Promise<void>;
}

export const TutorialStep = (id: string, run: (r: Resolver) => Promise<void>) => ({ id, run });
